<template>
	<div class="container">
		<van-form @submit="onSubmit">
			<van-nav-bar title="上传营业执照" fixed left-text=""/>
			<div style="height: 48px"></div>
			<div class="wrapper">
				<div class="wrapper-div">
					<van-field
						input-align="right"
						error-message-align="right"
						v-model="submitParams.merId"
						name="商户编号"
						label="商户编号"
						maxlength="15"
						placeholder="请输入15位商户号"
						:rules="[{ required: true, message: '请输入商户编号' }]"
					/>
					<van-field
						input-align="right"
						error-message-align="right"
						v-model="submitParams.phoneNoSix"
						name="手机号后六位"
						label="手机号后六位"
						maxLength='6'
						placeholder="请输入手机号后六位"
						:rules="[{ required: true, message: '请输入手机号后六位' },
						{
						  validator: value => {
							return /^\d{6}$/
							.test(value)
						  },
						  message: '请输入手机号后六位',
						  trigger: 'onChange',
						}]"
					/>
				</div>
				<div class="wrapper-div-custom">
					<span style="color:#333;font-size: 18px;font-weight: 500">
						请上传营业执照信息
					</span>
				
					<div class="upload-div">
						<div class="upload-div-item">
							<uploadImage1
								:imgSrc="otherImage"
								submit-field="upFileUrl5"
								type="other"
								img-class-name="upload-other-img"
								file-type="1"
								@uploadSuccess="uploadSuccess"
								@deleteImg="deleteImg"
							/>
							<span>营业执照照片</span>
						</div>
					</div>
				</div>
				<div class="wrapper-div">
					<van-field
						input-align="right"
						error-message-align="right"
						v-model="businessTypeName"
						name="营业执照类型"
						label="营业执照类型"
						placeholder="请选择"
						:rules="[{ required: true, message: '请选择营业执照类型' }]"
						readonly
						@click="openTypeSelect"
					/>
					<van-action-sheet v-model="showTypeSelect" :actions="typeActions" 
						@select="onTypeSelect" />
					<van-field
						input-align="right"
						error-message-align="right"
						v-model="submitParams.businessLicenseName"
						name="营业执照名称"
						label="营业执照名称"
						placeholder="请输入"
						:rules="[{ required: true, message: '请输入营业执照名称' }]"
					/>
					<van-field
						input-align="right"
						error-message-align="right"
						v-model="submitParams.busNo"
						name="营业执照号"
						label="营业执照号"
						placeholder="请输入"
						:rules="[{ required: true, message: '请输入营业执照号' }]"
					/>
					<div class="time-div" style="display: flex;justify-content: space-between;">
						<div class="time-title">营业执照有效期</div>
						<div class="time-box">
							<!-- <a-range-picker v-model:value="submitParams.date"/> -->
							<el-date-picker
								style="width: 100%;"
							    v-model="submitParams.date"
								value-format="yyyy-MM-dd"
							    type="daterange"
								range-separator="至"
							    start-placeholder="开始日期"
							    end-placeholder="结束日期"
								:editable="false"
							>
							</el-date-picker>
						</div>
					</div>
				</div>
			</div>
			<div class="button-text">
				<van-button round block color="linear-gradient(to right, #FFCE05, #FBC002)" native-type="submit">
					提交
				</van-button>
			</div>
		</van-form>
	</div>
</template>

<script>
import uploadImage1 from '@/components/UploadImage1.vue'
import otherImage from '@/assets/images/upload_other.png'
export default{
	components: {
	  uploadImage1
	},
	data() {
		return {
			otherImage: otherImage,
			showTypeSelect: false,
			typeActions: [],
			businessTypeName: '',
			submitParams: {
				merId: '',
				phoneNoSix: '',
				upFileUrl5: '',
				mercTyp: '',
				businessLicenseName: '',
				busNo: '',
				date: '',
			},
		}
	},
	mounted() {
		this.getDictData()
	},
	methods: {
		openTypeSelect(){
			this.showTypeSelect = true;
		},
		onTypeSelect(item) {
			// 默认情况下，点击选项时不会自动关闭菜单
			// 可以通过 close-on-click-action 属性开启自动关闭
			this.showTypeSelect = false;
			this.businessTypeName = item.name
			this.submitParams.mercTyp = item.value
		},
		uploadSuccess({ type, imgBase64, data, field }) {
		  this.submitParams[field] = imgBase64
		},
		deleteImg({type, field}){
			this.submitParams[field] = ''
		},
		onSubmit(){
			if (!this.submitParams.upFileUrl5) {
			  this.$toast('请上传营业执照照片', { type: 'fail' })
			  return
			}
			if (!this.submitParams.date) {
			  this.$toast('请选择营业执照有效期', { type: 'fail' })
			  return
			}
			let param = {...this.submitParams}
			param.licenseBeginDate = param.date[0].replace(/-/g, '')
			param.licenseEndDate = param.date[1].replace(/-/g, '')
			delete param.date
			console.log('参数',param)
			this.jsonPostRequest('/api/cold-butler-compose/merH5/businessInfoSupplement', param).then(res => {
			 console.log('返回数据',res)
			  if (res && res.data.code === 200) {
				this.$dialog.alert({
				  title: '提示',
				  message: res.data.msg,
				  confirmButtonText: '确认'
				}).then(() => {
				  window.location.reload()
				});
			  } else {
			    this.$toast(res.data.msg, { type: 'fail' })
			  }
			})
		},
		getDictData(){
			let params = {
				code: 'supH5MerType'
			}
			this.getRequest('/api/cold-light-core/dict/child-list', params).then(res => {
			  if (res && res.data.code === 200) {
				let list = res.data.data ? res.data.data : []
				let temp = []
				list.map((item)=>{
					temp.push({
						name: item.dictValue,
						value: item.dictKey
					})
				})
				this.typeActions = temp
			  }
			})
		}
	}
}
</script>

<style>
	.container {
		width: 100vw;
		height: 100vh;
		overflow: auto;
		background-color: #f5f5f5;
	}
	.wrapper {
	}
	.wrapper-div-custom{
		background-color: #fff;
		border-radius: 5px;
		padding: 5px 10px;
		margin: 10px 15px 0;
	}
	.wrapper-div {
		background-color: #fff;
		border-radius: 5px;
		padding: 5px 10px;
		margin: 10px 15px 0;
	}
	.upload-div {
	  display: flex;
	  justify-content: center;
	  margin-top: 10px;
	}
	.upload-div-item {
	  background-color: #fffbf3;
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  justify-content: center;
	  height: 110px;
	  width: 150px;
	}
	.time-div{
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px;
		box-sizing: border-box;
		width: 100%;
	}
	.time-title{
		font-size: 0.37333rem;
		line-height: 0.64rem;
		color: #646566;
		text-align: left;
		word-wrap: break-word;
	}
	.time-box{
		width: 65%;
	}
	.button-text {
	  height: 60px;
	  width: 100%;
	  background-color: #fff;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  position: fixed;
	  bottom: 0;
	}
	@media (max-width: 768px) {
		.el-date-range-picker .el-picker-panel__body {
			min-width: 100% !important;
		}
 
		.el-date-range-picker__content {
			width: 100% !important;
		}
 
		.el-date-range-picker {
			width: 95% !important;
		}
 
		.el-date-range-picker__content {
			margin: 0px !important;
			padding: 5px !important;
		}
 
		.el-date-range-picker__content.is-left {
			padding-bottom: 0px !important;
		}
 
		.el-date-range-picker__content.is-right {
			padding-top: 0px !important;
		}
 
		.el-date-table th {
			padding: 0px !important;
			text-align: center;
		}
 
		.el-date-table td {
			padding: 0px !important;
		}
	}
	.el-date-editor .el-range-input{
		width: 43% !important;
	}
	.el-date-editor .el-range__close-icon{
		width: 0px !important;
	}
	.el-date-editor .el-range-separator{
		width: 12% !important;
	}
</style>